export default __webpack_public_path__ + "static/radler-6a87dd30f2f1a5294874704acf65f9dc.svg";